<ng-container *ngIf="data == 'offline'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">You are offline</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content>
        <div>
            Certain features such as login and premium voices are disabled
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-flat-button class="btn-pw-alert-single" color="primary">OK</button>
    </mat-dialog-actions>
</ng-container>

<!-- <ng-container *ngIf="data == 'upgrade'">
    <div class="mat-dialog-title empty-title">
        <div class="pw-dialog-header">
            
            <div class="pw-dialog-title"></div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div>
            Please upgrade to Plus Plan to use this feature with Plus Voices
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-flat-button class="btn-pw-alert-single" color="primary" (click)="closeDialog()">ORDER NOW</button>
    </mat-dialog-actions>
</ng-container> HAS BEEN MOVED TO /src/app/modules-2022/lazy-loaded/pdf-reader/components/file-viewer/-->

<ng-container *ngIf="data == 'continue'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Sign up to continue</div>
            <!-- <button mat-icon-button aria-label="close button" class="pw-dialog-close" mat-dialog-close>
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button> -->
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content class="continue-content">
        <div class="continue-list">
            <ul>
                <li>Free forever</li>
                <li>Added layer of security for your documents</li>
                <li>Save your files, and enjoy more personalized services</li>
            </ul>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="continue-actions">
        <button mat-flat-button class="btn-full" color="primary" [mat-dialog-close]="'google'">CONTINUE WITH
            GOOGLE</button>
        <!-- <button mat-button>Sign up with apple</button> -->
        <button mat-button color="primary" [mat-dialog-close]="'signup'">sign up</button>
        <button mat-button [mat-dialog-close]="'skip'">skip</button>
        <button mat-button color="primary" [mat-dialog-close]="'login'">log in</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data == 'file not exist'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">File Expire</div>
            <button mat-icon-button aria-label="close button" class="pw-dialog-close" mat-dialog-close>
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content>
        This file has expired and has been removed. Please upload again.
    </div>
    <mat-dialog-actions>
        <button mat-flat-button color="primary" class="btn-full" (click)="closeDialog()">OK</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data == 'license error'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">License Error</div>
            <button mat-icon-button aria-label="close button" class="pw-dialog-close" mat-dialog-close>
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content>
        We're having trouble accessing your license information currently, please sign in below to try again.
    </div>
    <mat-dialog-actions>
        <button mat-flat-button color="primary" (click)="loginExpiredClick()" class="btn-full">Continue</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data == 'new voices'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title"></div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div>
            Demo our brand new Plus Voices! Featuring the newest and highest technology in AI powered voices
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-flat-button class="btn-full" color="primary">PREVIEW NOW</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data == 'commLicenseCheck'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Commercial License</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div>
            We've noticed you're using a commercial license. Would you like to go to the Commercial App?
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="btn-full" mat-flat-button color="primary" [mat-dialog-close]="'OK'">No Thanks</button>
        <button class="btn-full" mat-button color="primary" mat-dialog-close (click)="redirComm()">Redirect Now</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data == 'hotkey'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Hot Keys</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content class="hotkey-content">
        <div class="hotkey-line mat-body-2">
            <div>Pause / Resume:</div>
            <div class="hotkey-label">
                <!-- Ctrl + Shift + R -->
                Space
            </div>
        </div>
        <div class="hotkey-line mat-body-2">
            <div>Prev Sentence:</div>
            <div class="hotkey-label">
                <!-- Ctrl + Shift + Up -->
                Up
            </div>
        </div>
        <div class="hotkey-line mat-body-2">
            <div>Next Sentence:</div>
            <div class="hotkey-label">
                <!-- Ctrl + Shift + Down -->
                Down
            </div>
        </div>
    </div>
    <mat-dialog-actions>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data == 'upgrade'" aria-label="upgrade paid dialog">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Upgrade</div>
            <button mat-icon-button aria-label="close button" class="pw-dialog-close" mat-dialog-close>
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content>
        Please upgrade to a paid plan to access this feature.
    </div>
    <mat-dialog-actions>
        <button mat-flat-button color="primary" class="btn-full" (click)="showUpgrade('prem')"
            aria-label="order now button [upgrade dialog]">ORDER NOW</button>
        <button mat-button color="primary" class="btn-full" (click)="restoreLicenseClick()">RESTORE LICENSE</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data == 'yearly'" aria-label="upgrade paid dialog">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Upgrade To Yearly?</div>
            <button mat-icon-button aria-label="close button" class="pw-dialog-close" mat-dialog-close>
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content>
        Please upgrade to a paid plan to access this feature.
    </div>
    <mat-dialog-actions>
        <button mat-flat-button color="primary" class="btn-full" (click)="showUpgrade('prem')"
            aria-label="order now button [upgrade dialog]">ORDER NOW</button>
        <button mat-button color="primary" class="btn-full" (click)="restoreLicenseClick()">RESTORE LICENSE</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data.type == 'order plus'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Upgrade to Plus</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content *ngIf="data.userRole=='free'">
        Please upgrade to Plus Plan to use this feature with Plus Voices.
    </div>
    <div mat-dialog-content *ngIf="data.userRole=='premium'">
        <p>You're currently on the Premium Plan. Please switch to a Premium Voice to use this feature or upgrade to
            Plus. (<a target="_blank"
                href="https://help.naturalreaders.com/en/articles/6898023-web-app-free-paid-plans#h_0d6d7b134f">more
                info</a>)</p>
        <p *ngIf="appName=='pw' && !data.orderDisabled && isProrateAvailable">You'll be charged the prorated difference
            in price: {{prorate}}</p>
    </div>
    <mat-dialog-actions>
        <button mat-flat-button color="primary" class="btn-full" [disabled]="data.orderDisabled"
            (click)="showUpgrade('plus')">Upgrade Now</button>
        <button mat-button color="primary" class="btn-full" (click)="restoreLicenseClick()">Restore License</button>
        <div *ngIf="data.orderDisabled" class="pw-text-bold">({{data.unsupportedMsg}})</div>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data.type == 'upgrade plus'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Upgrade to Yearly Plus Plan?</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content>
        <div class="pw-upgrade-plus">
            <b>It only costs the difference in price</b> <br>
            <b>{{prorate}} / first payment</b> <br>
            or $119 USD / year for renewal
        </div>
    </div>
    <mat-dialog-actions>
        <button [disabled]="isUpgrading" mat-flat-button color="primary" class="btn-full" (click)="upgradeYearly()">upgrade now</button>
    </mat-dialog-actions>
    <div *ngIf="isUpgrading">Processing...</div>
</ng-container>

<ng-container *ngIf="data.type == 'alert'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">{{data.title}}</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content aria-label="checkout alert frame" class="nr-alert-content">
        <div class="mat-body-2" *ngIf="data.msg">{{data.msg}}</div>
        <div class="mat-body-2" *ngIf="data.html" [innerHtml]="data.html"></div>
    </div>
    <div mat-dialog-actions>
        <button class="btn-full" mat-flat-button color="primary" [mat-dialog-close]="'OK'">{{data.buttonText}}</button>
        <button class="btn-full" mat-button color="primary" mat-dialog-close *ngIf="!data.hideCancel">CANCEL</button>
    </div>
</ng-container>

<ng-container *ngIf="data.type == 'openPayment'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Error</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content aria-label="checkout alert frame" class="nr-alert-content">
        <div class="mat-body-2">You have already tried our Plus Yearly 3-day Trial or are not a new customer. Please
            purchase a <a style="cursor: pointer; text-decoration: underline;" (click)="openPayment()"> subscription
                here.</a></div>
    </div>
    <div mat-dialog-actions>
        <button class="btn-full" mat-flat-button color="primary" [mat-dialog-close]="'OK'">OK</button>
    </div>
</ng-container>

<ng-container *ngIf="data.type == 'old'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">
                <div *ngIf="data['title'] != null">{{data['title']}}</div>
                <div *ngIf="data['htmlTitle']" [innerHtml]="data['htmlTitle']" matTooltipPosition="above"
                    [matTooltip]="data['titleTooltip']"></div>
            </div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content class="nr-alert-content" aria-label="dialog alert container">
        <h4 *ngIf="data['text']">{{data['text']}}</h4>
        <h4 *ngIf="data['htmlText']" [innerHtml]="data['htmlText']" matTooltipPosition="above"
            [matTooltip]="data['textTooltip']"></h4>
    </mat-dialog-content>
    <mat-dialog-actions class="nr-alert-actions">
        <button *ngIf="data['button_left'] != null" mat-button aria-label="alert left button"
            [mat-dialog-close]="data['button_left']">
            {{data['button_left']}}
        </button>
        <button *ngIf="data['button_center'] != null" mat-flat-button color="primary" aria-label="alert center button"
            [mat-dialog-close]="data['button_center']">
            {{data['button_center']}}
        </button>
        <button *ngIf="data['button_right'] != null" mat-flat-button color="primary" aria-label="alert right button"
            [mat-dialog-close]="data['button_right']" [disabled]="data['button_right_disabled']">
            {{data['button_right']}}
        </button>
        <h4 class="text-center" color="warning" *ngIf="data['unsupportedMsg']">({{data['unsupportedMsg']}})</h4>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data === 'install'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Download Apps</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content class="install-content">
        <button class="btn-full" (click)="viewChromeExtension()" aria-label="download chrome extension" mat-button>
            <img class="install-img" src="https://wwwnaturalreaderscom.s3.amazonaws.com/images/installChrome.svg"
                alt="Chrome Extension" loading="lazy" (load)="loadIcon('chrome')">
            <span class="install-text" *ngIf="showChrome">Download Chrome Extension</span>
        </button>
        <button class="btn-full" (click)="viewIOSApp()" aria-label="download naturalreader ios app" mat-button>
            <img class="install-img" src="https://wwwnaturalreaderscom.s3.amazonaws.com/images/installApple.svg"
                alt="iOS App" loading="lazy" (load)="loadIcon('apple')">
            <span class="install-text" *ngIf="showApple">Download NaturalReader iOS App</span>
        </button>
        <button class="btn-full" (click)="viewAndroidApp()" aria-label="download naturalreader android app" mat-button>
            <img class="install-img" src="https://wwwnaturalreaderscom.s3.amazonaws.com/images/installGoogle.svg"
                alt="Google Play App" loading="lazy" (load)="loadIcon('google')">
            <span class="install-text" *ngIf="showGoogle">Download NaturalReader Android App</span>
        </button>
        <button class="btn-full" (click)="installApp()" aria-label="install desktop icon" [disabled]="!canInstallApp"
            mat-button>
            <img class="install-img" src="https://wwwnaturalreaderscom.s3.amazonaws.com/images/installDesktop.svg"
                alt="Install Desktop Icon" loading="lazy" (load)="loadIcon('desktop')">
            <span class="install-text" *ngIf="showDesktop"> Install desktop icon </span>
        </button>
    </mat-dialog-content>
</ng-container>

<ng-container *ngIf="data.op == 'share'">
    <div class="mat-dialog-title">
        <div class="title-center">Share</div>
        <button mat-icon-button aria-label="close button" class="pw-dialog-close" (click)="closeDialog()"
            mat-dialog-close>
            <svg class="nr-icon-18">
                <use xlink:href="#pw_close"></use>
            </svg>
        </button>
    </div>
    <mat-dialog-content>
        <mat-form-field appearance="outline">
            <input matInput aria-label="share input" type="text" cdkFocusInitial
                placeholder="https://naturalreaders.com" [(ngModel)]="shareURL" readonly>
        </mat-form-field>
        <button mat-flat-button aria-label="copy button" color="primary" (click)="copyLink()">Copy Link</button>
    </mat-dialog-content>
</ng-container>
<ng-container *ngIf="data == 'manualOCR'" aria-label="convert document to text dialog (Paid)">
    <div class="mat-dialog-title">
        <!-- <div class="pw-dialog-header"> -->
        <!-- <div class="pw-dialog-title">Convert Document to Text</div> -->
        <button mat-button class="pw-dialog-back" mat-dialog-close="backToMenu">
            <svg class="nr-icon-14">
                <use xlink:href="#nr_arrow_left"></use>
            </svg>
            <span class="pw-text-normal">Back</span>
        </button>
        <div class="title-text">
            Scan to Text
        </div>
        <button mat-icon-button aria-label="close button" class="pw-dialog-close" mat-dialog-close>
            <svg class="nr-icon-24">
                <use xlink:href="#pw_close"></use>
            </svg>
        </button>
        <!-- </div>
        <mat-divider></mat-divider> -->
    </div>
    <div mat-dialog-content>
        Capture page image and convert into text. Recommended for files containing images, skipped text, or unrecognized
        columns.
    </div>
    <mat-dialog-actions>
        <button mat-flat-button color="primary" class="btn-full" (click)="manualOCR()"
            aria-label="manualOCR next button">Next</button>
    </mat-dialog-actions>
</ng-container>


<ng-container *ngIf="data == 'downloadAnnotationPDF'" aria-label="download annotation pages to pdf">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Download annotation pages to pdf.</div>
            <button mat-icon-button aria-label="close button" class="pw-dialog-close" mat-dialog-close>
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content>
        Uploading annotation pages and generating pdf file.
    </div>
</ng-container>


<ng-container *ngIf="data == 'manualOCR upgrade'" aria-label="convert document to text dialog (not Paid)">
    <div class="mat-dialog-title">
        <!-- <div class="pw-dialog-header">
            <div class="pw-dialog-title">Convert Document to Text</div>
            <button mat-icon-button aria-label="close button" class="pw-dialog-close" mat-dialog-close>
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider> -->
        <button mat-button class="pw-dialog-back" mat-dialog-close="backToMenu">
            <svg class="nr-icon-14">
                <use xlink:href="#nr_arrow_left"></use>
            </svg>
            <span class="pw-text-normal">Back</span>
        </button>
        <div class="title-text">
            Scan to Text
        </div>
        <button mat-icon-button aria-label="close button" class="pw-dialog-close" mat-dialog-close>
            <svg class="nr-icon-24">
                <use xlink:href="#pw_close"></use>
            </svg>
        </button>
    </div>
    <div mat-dialog-content>
        Capture page image and convert into text. Recommended for files containing images, skipped text, or unrecognized
        columns.
    </div>
    <mat-dialog-actions>
        <button mat-flat-button color="primary" class="btn-full" (click)="showUpgrade('prem')"
            aria-label="upgrade button (scan to text)">Upgrade</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data === 'need-login'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Login Required</div>
            <button mat-icon-button aria-label="close button" class="pw-dialog-close" [mat-dialog-close]="'close'">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content>
        Please sign up or login to use this feature
    </div>
    <mat-dialog-actions align="end">
        <button mat-button color="primary" [mat-dialog-close]="'signup'" (click)="loginBtnonClick()">
            SIGN UP
        </button>
        <button mat-stroked-button color="primary" (click)="loginBtnonClick()" [mat-dialog-close]="'login'">
            LOGIN
        </button>
    </mat-dialog-actions>
</ng-container>


<ng-container *ngIf="data == 'app'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Download App</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content class="pw-app-download">
        <div class="pw-app-top">
            Download Mobile App for Exclusive Features!
        </div>
        <svg class="nr-icon-64">
            <use xlink:href="#pw_login_logo"></use>
        </svg>
        <ul class="pw-app-feature">
            <li>Clone your own voice for free</li>
            <li>Use camera to capture and listen</li>
            <li>Easily access cloud documents</li>
            <li>Listen while phone is in sleep mode</li>
        </ul>

    </mat-dialog-content>
    <mat-dialog-actions class="pw-app-download-action">
        <button mat-flat-button color="primary" class="btn-full" (click)="utilService.openDownloadApp()">
            Download app
        </button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data == 'pwa'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Installation Successful</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content class="pw-app-download">
        <div class="pw-app-top pw-text-dark">
            Launch NaturalReader from your desktop next time
        </div>
        <svg class="nr-icon-64">
            <use xlink:href="#pw_login_logo"></use>
        </svg>
    </mat-dialog-content>
</ng-container>

<ng-container *ngIf="data == 'pin'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Pin in Dock</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content class="pw-app-download">
        <img class="pw-pin-img" src="assets/img/pin.png" alt="Pin in Dock" loading="lazy">
        <!-- <img class="pw-pin-img" src="https://wwwnaturalreaderscom.s3.amazonaws.com/images/pin2.svg" alt="Dock" loading="lazy"> -->
    </mat-dialog-content>
</ng-container>

<ng-container *ngIf="data.type == 'edu'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Upgrade</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content>
        <div *ngIf="!emailSend">
            <p>
                Please contact the owner of the account ({{data['ownerEmail']}}) to upgrade to the premium plan.
            </p>
            <p>
                Or you can <a class="pw-highlight-hover" (click)="checkOut('')">purchase the individual plan
                    instead.</a>
            </p>
        </div>
        <div *ngIf="emailSend" aria-label="email has been sent">
            <p>
                Email has been sent out successfully
            </p>
        </div>
    </div>
    <mat-dialog-actions>
        <button mat-button color="primary" class="btn-full" (click)="restoreLicenseClick()">RESTORE LICENSE</button>
        <button *ngIf="!emailSend" mat-flat-button color="primary" class="btn-full" aria-label="contact owner button"
            (click)="sendEmail('eduPrem')">CONTACT OWNER</button>
        <button *ngIf="emailSend" mat-flat-button color="primary" class="btn-full" aria-label="ok button"
            mat-dialog-close>OK</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data.type == 'edu-plus'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Upgrade to PLus</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content>
        <div *ngIf="!emailSend">
            <p>
                Please contact the subscription owner ({{data['ownerEmail']}}) to upgrade to Plus Group License.
            </p>
            <p>
                Or you can <a class="pw-highlight-hover" (click)="checkOut('')">purchase an individual plan instead.</a>
            </p>
        </div>
        <div *ngIf="emailSend" aria-label="email has been sent">
            <p>
                Email has been sent out successfully
            </p>
        </div>
    </div>
    <mat-dialog-actions>
        <button mat-button color="primary" class="btn-full" (click)="restoreLicenseClick()">RESTORE LICENSE</button>
        <button *ngIf="!emailSend" mat-flat-button color="primary" class="btn-full" aria-label="contact owner button"
            (click)="sendEmail('eduPlus')">CONTACT OWNER</button>
        <button *ngIf="emailSend" mat-flat-button color="primary" class="btn-full" aria-label="ok button"
            mat-dialog-close>OK</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data.type == 'ttsUsage'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Daily TTS Usage</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content class="nr-text-center">
        <div *ngIf="data.userMetadata['charsUsedPremTtsFree'] != undefined">
            Premium: {{data.userMetadata.charsUsedPremTtsFree}} / 20000
        </div>
        <div *ngIf="data.userMetadata['charsUsedPremTtsPaid'] != undefined">
            Premium: {{data.userMetadata.charsUsedPremTtsPaid}}
        </div>
        <div *ngIf="data.userMetadata['charsUsedPlusTtsFree'] != undefined">
            Plus: {{data.userMetadata.charsUsedPlusTtsFree}} / 4000
        </div>
        <div *ngIf="data.userMetadata['charsUsedPlusTtsPaid'] != undefined">
            Plus: {{data.userMetadata.charsUsedPlusTtsPaid}} / 500000
        </div>
    </mat-dialog-content>
    <!-- <mat-dialog-actions>
        <button mat-flat-button class="btn-pw-alert-single" color="primary">OK</button>
    </mat-dialog-actions> -->
</ng-container>

<ng-container *ngIf="data == 'restore license'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Restore License</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content style="text-align: left; line-height: 2;">
        Restore your subscription license. You will be asked to login again.
        <br>
    </div>
    <mat-dialog-actions>
        <button mat-button color="primary" mat-dialog-close>CANCEL </button>
        <button mat-flat-button color="primary" (click)="loginExpiredClick()">RESTORE LICENSE</button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data == 'reActivatingCloned'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">
                <span>Preparing</span>
            </div>
        </div>
    </div>
    <mat-dialog-actions>
        <button mat-button color="primary" mat-dialog-close="cancel">CANCEL</button>
    </mat-dialog-actions>
</ng-container>

<!-- TODO Need to check if using for download cloned voice -->
<!-- <ng-container *ngIf="data == 'downloadPDF'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Download PDF</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div mat-dialog-content class="loader-cloned-content pw-text-dark">
        <div *ngIf="loadingCloned">
            <div>It may take a couple of minutes to prepare the voice.</div>
            <div class="pw-cloned-loader">
                <div>Checking</div>
                <div class="loader">
                    <div class="point1"></div>
                    <div class="point2"></div>
                    <div class="point3"></div>
                </div>
            </div>
        </div>
        <div *ngIf="!loadingCloned">
            The voice is ready, please click Play button to start.
        </div>
    </div>
    <mat-dialog-actions class="loader-cloned-actions">
        <button mat-button color="primary" class="nr-text-underline" *ngIf="!loadingCloned">
            Got It
        </button>
    </mat-dialog-actions>
</ng-container> -->
<!-- TODO Need to check if using for download cloned voice -->

<ng-container *ngIf="data.type ==='editVoice'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Edit Voice</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content class="pw-editName-content">
        <mat-form-field appearance="outline" class="w-100" [formGroup]="voiceNameFormGroup">
            <input matInput placeholder="Name Your Voice" formControlName="voiceNameControl" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100" [formGroup]="descriptionFormGroup">
            <input matInput placeholder="Description (Optional)" formControlName="descriptionControl">
        </mat-form-field>

        <div class="cloned-voice-tags">
            <button mat-stroked-button class="cloned-voice-tag" *ngFor="let item of voice_tags"
                [ngClass]="{'selected': selectedTag(item)}" (click)="addTag(item)">
                <span>{{item}}</span>
                <svg class="nr-icon-16 icon-indigo">
                    <use xlink:href="#pw_done"></use>
                </svg>
            </button>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="d-flex-center">
        <button mat-flat-button color="primary" [disabled]="!voiceNameFormGroup.controls.voiceNameControl.value"
            (click)="updateVoice()">
            Done
        </button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data.type === 'shareVoice'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Edit Voice Sharing</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content>
        <mat-radio-group class="clone-share-group" [(ngModel)]="share_Option" color="primary" (change)="hasSharingAgeConsent = false">
            <mat-radio-button class="clone-share-cell" value="community">
                <div class="pw-text-dark">Share with Community
                    <button mat-icon-button class="pw-clone-help">
                        <svg class="nr-icon-18">
                            <use xlink:href="#pw_help"></use>
                        </svg>
                    </button>
                </div>
                <div class="pw-text-normal">Share your voice to help others</div>
            </mat-radio-button>
            <mat-radio-button class="clone-share-cell" value="custom">
                <div class="pw-text-dark">Share with Custom</div>
                <div class="pw-text-normal">Share privately with friends</div>
            </mat-radio-button>
            <div class="w-100" *ngIf="share_Option == 'custom'">
                <div class="clone-share-title">Enter an email and click + to add:</div>
                <mat-form-field appearance="outline" class="clone-share-email w-100">
                    <input matInput placeholder="Enter an email and click + to add" type="email"
                        [formControl]="emailFormControl" [(ngModel)]="shareEmailInput">
                    <button mat-icon-button matSuffix (click)="addEmail(shareEmailInput); shareEmailInput=''"
                        [disabled]="emailFormControl.invalid || !shareEmailInput">
                        <svg class="nr-icon-24 icon-primary">
                            <use xlink:href="#pw_add"></use>
                        </svg>
                    </button>
                    <mat-error *ngIf="emailFormControl.invalid">
                        Please enter a valid email.
                    </mat-error>
                </mat-form-field>
                
                <div class="d-flex-between pw-text-normal">
                    <mat-chip-list aria-label="email for share" [selectable]="false">
                        <mat-chip *ngFor="let email of shareEmails" (removed)="remove(email)">
                            {{email}}
                            <button matChipRemove>
                                <svg class="nr-icon-18">
                                    <use xlink:href="#pw_close"></use>
                                </svg>
                            </button>
                        </mat-chip>
                    </mat-chip-list>
                </div>
            </div>
    
            <mat-radio-button class="clone-share-cell" value="none">
                <div class="pw-text-dark">Don&rsquo;t Share</div>
                <div class="pw-text-normal">I don&rsquo;t want to help right now</div>
            </mat-radio-button>
            <div class="w-100" *ngIf="share_Option == 'community'">
                <mat-checkbox color="primary" class="community_box" [(ngModel)]="hasSharingAgeConsent">
                    I am over 18 years old and consent to share my voice with our community of personal users.
                </mat-checkbox>
              </div>
        </mat-radio-group>
    </mat-dialog-content>


    <mat-dialog-actions class="d-flex-center">
        <button mat-flat-button color="primary" (click)="updateVoiceSharing()" [disabled]="share_Option ==='community' && !hasSharingAgeConsent">
            Done
        </button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="data == 'downloadPDF'">
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Download PDF</div>
            <button mat-icon-button class="pw-dialog-close" (click)="closeDialog()">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>
    </div>
    <mat-dialog-content class="pw-app-download pw-download-pdf">
        <div class="pw-app-top pw-text-dark">
            Do you want to download the PDF file with the annotation highlights?
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="pw-download-pdf-actions">
        <button mat-flat-button color="primary" class="btn-full" (click)="exportPdf(true)">
            PDF with Annotations
        </button>
        <button mat-button color="primary" class="btn-full nr-text-underline" (click)="exportPdf(false)">
            PDF Only
        </button>
    </mat-dialog-actions>
</ng-container>

<svg width="0" height="0" class="hidden">
    <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 68" id="pw_login_logo">
        <path
            d="M0 2.46381C0 1.10309 1.1031 0 2.46384 0C3.82458 0 4.92767 1.10308 4.92767 2.4638V65.5371C4.92767 66.8979 3.82458 68.0009 2.46384 68.0009C1.1031 68.0009 0 66.8979 0 65.5371V2.46381Z"
            fill="#0078D4"></path>
        <path
            d="M7.88184 2.46381C7.88184 1.10309 8.98493 0 10.3457 0C11.7064 0 12.8095 1.10308 12.8095 2.4638V65.5371C12.8095 66.8979 11.7064 68.0009 10.3457 68.0009C8.98493 68.0009 7.88184 66.8979 7.88184 65.5371V2.46381Z"
            fill="#0078D4"></path>
        <path
            d="M15.7715 2.46381C15.7715 1.10309 16.8746 0 18.2353 0C19.5961 0 20.6992 1.10308 20.6992 2.4638V65.5371C20.6992 66.8979 19.5961 68.0009 18.2353 68.0009C16.8746 68.0009 15.7715 66.8979 15.7715 65.5371V2.46381Z"
            fill="#0078D4"></path>
        <path
            d="M23.6533 12.7773C23.6533 11.4166 24.7564 10.3135 26.1172 10.3135C27.4779 10.3135 28.581 11.4166 28.581 12.7773V39.7553C28.581 41.1161 27.4779 42.2191 26.1172 42.2191C24.7564 42.2191 23.6533 41.116 23.6533 39.7553V12.7773Z"
            fill="#0078D4"></path>
        <path
            d="M31.54 22.399C31.54 21.0641 32.6431 19.9819 34.0039 19.9819C35.3646 19.9819 36.4677 21.0641 36.4677 22.399V48.8259C36.4677 50.1609 35.3646 51.243 34.0039 51.243C32.6431 51.243 31.54 50.1609 31.54 48.8259V22.399Z"
            fill="#0078D4"></path>
        <path
            d="M39.4189 30.8246C39.4189 29.4639 40.522 28.3608 41.8828 28.3608C43.2435 28.3608 44.3466 29.4639 44.3466 30.8246V58.125C44.3466 59.4857 43.2435 60.5888 41.8828 60.5888C40.522 60.5888 39.4189 59.4857 39.4189 58.125V30.8246Z"
            fill="#0078D4"></path>
        <path
            d="M47.3037 2.46381C47.3037 1.10309 48.4068 0 49.7675 0C51.1283 0 52.2314 1.10308 52.2314 2.4638V65.5371C52.2314 66.8979 51.1283 68.0009 49.7675 68.0009C48.4068 68.0009 47.3037 66.8979 47.3037 65.5371V2.46381Z"
            fill="#0078D4"></path>
        <path
            d="M55.1904 2.46381C55.1904 1.10309 56.2935 0 57.6543 0C59.015 0 60.1181 1.10308 60.1181 2.4638V65.5371C60.1181 66.8979 59.015 68.0009 57.6543 68.0009C56.2935 68.0009 55.1904 66.8979 55.1904 65.5371V2.46381Z"
            fill="#0078D4"></path>
        <path
            d="M63.0723 2.46381C63.0723 1.10309 64.1754 0 65.5361 0C66.8968 0 67.9999 1.10308 67.9999 2.4638V65.5371C67.9999 66.8979 66.8968 68.0009 65.5361 68.0009C64.1754 68.0009 63.0723 66.8979 63.0723 65.5371V2.46381Z"
            fill="#0078D4"></path>
    </symbol>
</svg>